import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyState = ({ title = 'Nothing here yet', message = '', actionLabel, onAction, icon: IconComponent = InboxIcon }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      gap: 2,
      color: 'text.secondary'
    }}
  >
    <IconComponent sx={{ fontSize: 64, opacity: 0.4 }} />
    <Typography variant="h6">{title}</Typography>
    {message && (
      <Typography variant="body2" align="center" sx={{ maxWidth: 360 }}>
        {message}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="contained" onClick={onAction} sx={{ mt: 1 }}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
